import { Component, Vue } from "vue-property-decorator";

import { BlankPage, Loading, Hint } from "@/components";
import { Reconciliation, Common } from "@/constant";
import { ReimbursementModel } from "@/models";
import { TCBReceiptApi } from "@/network/pb/proto";

import { Priv } from "@/util/Priv";
import { DefaultPath } from "@/constant/GroupPermission";

// 特店 - 子項目 (每個特店資訊)
type Store = {
    id: number;
    code: string;
    name: string;
    selected: boolean;
};

// 特店 - 主項目 (統編號碼 + 全選)
type StoreGroup = {
    tidNumber: string;
    selected: boolean;
    storeList: Store[];
};

// 列表 - 彙總
type GroupItem = {
    terminalNo: string;
    date: string;
    batchNo: string;
    count: number;
    amount: number;
    infoType: number;
};

@Component<ReconciliationReimbursementPrintController>({
    components: {
        BlankPage,
        Hint,
        Loading,
    },
})
export default class ReconciliationReimbursementPrintController extends Vue {
    private isLoading = false; // 控制顯示header

    // 搜尋引擎 - 空用元件
    private periodMap = Reconciliation.PeriodMap;
    private transactionMap = Reconciliation.TransactionMap;
    private noteMap = Reconciliation.NoteMap;
    private cardMap = Reconciliation.CardMap;
    private minDate = "";
    private maxDate = "";

    private searchItem: {
        storeType: number;
        tidNumber: string;
        storeArr: string[];
        type: number;
        periodType: number;
        start: string;
        end: string;
        transactionType: number;
        noteType: number;
        cardType: string[];
        cardNum: string;
        orderNum: string;
        machineCodeStart: string;
        machineCodeEnd: string;
        approvalCode: string;
    } = {
            storeType: 0,
            tidNumber: "",
            storeArr: [],
            type: 1,
            periodType: 1,
            start: "",
            end: "",
            transactionType: 0,
            noteType: 1,
            cardType: ["1", "2", "3", "4", "5"],
            cardNum: "",
            orderNum: "",
            machineCodeStart: "",
            machineCodeEnd: "",
            approvalCode: "",
        };
    private datePeriodStartMax = "";

    // 明細 - 取得卡別彙總
    private reimbursementSummary = TCBReceiptApi.Protobuf.ReimbursementSummary.create();

    // 選取特約清單 => 是否展開LB
    private storeGroupList: StoreGroup[] = [];
    private isOpenStoreLB = false;

    // filter => 明細, 依端末機彙總, 依結帳請款日彙總
    private filterType = "date";

    // 列表
    private reconciliationList: TCBReceiptApi.Protobuf.IReconciliation[] = []; // 什麼時候需要加I  (Store => IStore)
    // 自己觀察是如果使用 賦予值=create() 則可以直接使用pb; 如果是先定義型別再初始化的寫法會對應不到pb
    private reimbursementCollectionMap = TCBReceiptApi.Protobuf.ReimbursementCollectionMap.create();
    private reimbursementTotal = TCBReceiptApi.Protobuf.ReimbursementTotal.create();
    // 列表 - 依結帳請款日彙總
    // private byDateMap: {[k: string]: TCBReceiptApi.Protobuf.ReimbursementInfo[]} = {};
    private byGroupDateMap: { [k: string]: GroupItem[] } = {};
    private byGroupDateTableMap: { [k: string]: TCBReceiptApi.Protobuf.ReimbursementInfo[] } = {};
    // 列表 - 依端末機彙總
    private byGroupTerminalMap: { [k: string]: GroupItem[] } = {};
    private byGroupTerminalTableMap: { [k: string]: TCBReceiptApi.Protobuf.ReimbursementInfo[] } = {};
    // 列表 - 明細
    private byTerminalNoMap: { [k: string]: TCBReceiptApi.Protobuf.ReimbursementInfo[] } = {};

    // 展開收合
    private isUnfold = false;
    private unfoldList: string[] = [];

    // 展開明細
    private showAllList: string[] = [];

    // 查看明細 => 是否展開LB
    private isOpenDetailLB = false;
    private detailTitle: object = {};
    private detail = TCBReceiptApi.Protobuf.ReimbursementInfo.create();
    private detailType = 1; // 預設 1 => 請款, 2 => 撥款

    // 查看批號明細 => 是否展開LB
    private isOpenTableLB = false;
    private batchNoTitle = TCBReceiptApi.Protobuf.Reconciliation.create();
    private batchNoInfo: object = {};
    private tableType = 1; // 預設 1 => 請款, 2 => 撥款

    // LB
    private hintBox: { show: boolean, msg: string } = { show: false, msg: "" };

    public async created() {
        /* 取得最新的權限map並判斷有何權限 */
        await this.setPriv();
        /* 取得最新的權限map並判斷有何權限 */

        const storageItemJson = localStorage.getItem("FrontReconciliationReimbursement") as string;
        if (storageItemJson && storageItemJson !== "") {
            const storageItem = JSON.parse(storageItemJson) as { search: TCBReceiptApi.Protobuf.ReimbursementQuery, filterType: string };
            console.log(storageItem);

            const filterType = storageItem.filterType;
            const searchItem = storageItem.search;
            const reimbursementQuery = TCBReceiptApi.Protobuf.ReimbursementQuery.encode(searchItem).finish();

            this.changeFilter(filterType);
            await this.searchByCondition(reimbursementQuery);
            window.print();
        } else {
            this.openHint(Common.ErrorCodeMap[Common.ErrorHintMap.PrintEmptyData]);
            return false;
        }
    }

    /* LB */
    private openHint(msg: string) {
        this.hintBox.msg = msg;
        this.hintBox.show = true;
    }

    private closeHint() {
        this.hintBox.msg = "";
        this.hintBox.show = false;
    }
    /* LB */

    /* 搜尋 */
    private async searchByCondition(reimbursementQuery: Uint8Array) {
        console.log("reimbursementQuery");
        console.log(reimbursementQuery);
        if (reimbursementQuery.length === 0) {
            this.openHint(Common.ErrorCodeMap[Common.ErrorHintMap.SettingPrintDataError]);
            return false;
        }

        this.isLoading = true;

        /* init */
        this.init();
        /* init */

        /* 取得列表 */
        await ReimbursementModel.getReimbursement(reimbursementQuery);
        const reimbursementList = ReimbursementModel.getReimbursementList();
        console.log("reimbursementList");
        console.log(reimbursementList);

        this.reconciliationList = reimbursementList.list;
        /* 取得列表 */

        /* 取得展開資料 - map */
        const reimbursementCollectionMap = await ReimbursementModel.getPrintReimbursementCollectionMap(reimbursementQuery);
        console.log("reimbursementCollectionMap");
        console.log(reimbursementCollectionMap);
        this.addTotalAndSubtotalFromMap(reimbursementCollectionMap.map);

        // 第一次預先展開
        this.unfoldList = [];
        Object.keys(reimbursementCollectionMap.map).forEach(
            (thisStoreCode) => {
                this.unfoldList.push(thisStoreCode);
            }
        );
        /* 取得展開資料 - map */

        /* 取得總計 */
        await ReimbursementModel.getReimbursementTotal(reimbursementQuery);
        this.reimbursementTotal = ReimbursementModel.getReimbursementTotalObj();
        /* 取得總計 */

        /* 取得卡別彙總 */
        await ReimbursementModel.getReimbursementSummary(reimbursementQuery);
        this.reimbursementSummary = ReimbursementModel.getReimbursementSummaryData();
        /* 取得卡別彙總 */

        this.isLoading = false;
    }
    /* 搜尋 */

    /* filter => 明細, 依端末機彙總, 依結帳請款日彙總 */
    private async changeFilter(type: string) {
        this.filterType = type;
    }
    /* filter => 明細, 依端末機彙總, 依結帳請款日彙總 */

    /* 其他 */
    private isNotNatureNum(val: string) {
        if (val) {
            const num = (val + "").replace(/,/g, "");
            return Number(num) <= 0;
        } else {
            return false;
        }
    }

    // 數字轉千分位 (number to string) ps.保留數字小數點至第二位
    private convertNumberToMoney(num: number) {
        if (!num) {
            return 0;
        }
        let a: string = (num + "").replace(/,/g, "");
        if (a.indexOf(".") != -1) {
            if (a.split(".")[1].length > 2) {
                a = Math.round(+a * 100) / 100 + "";
            }
            if (a.split(".").length == 2) {
                return (+a.split(".")[0]).toLocaleString() + "." + a.split(".")[1];
            } else {
                return (+a.split(".")[0]).toLocaleString();
            }
        } else {
            return (+a.split(".")[0]).toLocaleString();
        }
    }

    private addTotalAndSubtotalFromMap(storeCodeMap: { [k: string]: TCBReceiptApi.Protobuf.IReimbursementCollection; }) {
        if (storeCodeMap) {
            Object.keys(storeCodeMap).forEach(thisStoreCode => {
                // 明細 - 統計"特店合計""
                let storeCodeCountByDate = 0;
                let storeCodeSubtotalByDate = 0;

                const dateGroupNewInfoList: GroupItem[] = []; // 請款日彙總

                const dateMap = storeCodeMap[thisStoreCode].byDate as TCBReceiptApi.Protobuf.ReimbursementFirstMap;
                if (dateMap && dateMap.byFirstColumn) {
                    Object.keys(dateMap.byFirstColumn).forEach(thisDate => {
                        let dateSubtotal = 0; // 彙總 - 小計金額
                        let dateCount = 0; // 彙總 - 小計筆數

                        const terminalMap = dateMap.byFirstColumn[thisDate].bySecondColumn as { [k: string]: TCBReceiptApi.Protobuf.IReimbursementBatchNoMap };
                        if (terminalMap) {
                            Object.keys(terminalMap).forEach(thisTerminalNo => {
                                const batchNoMap = terminalMap[thisTerminalNo].byBatchNo as { [k: string]: TCBReceiptApi.Protobuf.Reimbursement };

                                if (batchNoMap) {
                                    Object.keys(batchNoMap).forEach(thisBatchNo => {
                                        const list = batchNoMap[thisBatchNo].list as TCBReceiptApi.Protobuf.ReimbursementInfo[];
                                        // 彙總 - Lb table
                                        const tableInfo: (TCBReceiptApi.Protobuf.ReimbursementInfo | GroupItem)[] = [];

                                        // 只統計該批號下的資料 批號小結
                                        const count = list.length;
                                        let subtotal = 0;
                                        let batchNo = "";

                                        list.forEach((thisInfo) => {
                                            if (thisInfo.infoType == 1) {
                                                // 彙總
                                                tableInfo.push(thisInfo);

                                                // 批號小結
                                                subtotal = subtotal + (thisInfo.amount as number);
                                                batchNo = thisInfo.batchNo as string; // 四碼
                                                // 每日小結
                                                dateCount = dateCount + 1;
                                                dateSubtotal = dateSubtotal + (thisInfo.amount as number);
                                                // 特店合計
                                                storeCodeCountByDate = storeCodeCountByDate + 1;
                                                storeCodeSubtotalByDate = storeCodeSubtotalByDate + (thisInfo.amount as number);
                                            }
                                        });

                                        // 依請款日彙總 - LB table - 批號小結
                                        const tableSubTotalItem: GroupItem =
                                        {
                                            terminalNo: "",
                                            date: "",
                                            batchNo: batchNo,
                                            count: count,
                                            amount: subtotal,
                                            infoType: 2, // 註記 = [1 => data, 2 => 批號小結]
                                        };
                                        tableInfo.push(tableSubTotalItem);

                                        // 依請款日彙總 - LB table
                                        this.$set(this.byGroupDateTableMap, thisBatchNo, tableInfo);

                                        // 依請款日彙總 - data
                                        const dateGroupItem: GroupItem =
                                        {
                                            terminalNo: thisTerminalNo,
                                            date: thisDate,
                                            batchNo: thisBatchNo,
                                            count: list.length,
                                            amount: subtotal,
                                            infoType: 1, // 註記 = [1 => data, 2 => 小計, 3 => 合計]
                                        };
                                        dateGroupNewInfoList.push(dateGroupItem);
                                    });
                                }
                            });
                        }

                        // 依請款日彙總 - 小計
                        if (dateGroupNewInfoList.length > 0) {
                            const dateGroupItem: GroupItem =
                            {
                                terminalNo: "",
                                date: "",
                                batchNo: "",
                                count: dateCount,
                                amount: dateSubtotal,
                                infoType: 2, // 註記 = [1 => data, 2 => 小計, 3 => 合計]
                            };
                            dateGroupNewInfoList.push(dateGroupItem);
                        }
                    });
                }

                // 依請款日彙總 - 合計
                const dateGroupItem: GroupItem =
                {
                    terminalNo: "",
                    date: "",
                    batchNo: "",
                    count: storeCodeCountByDate,
                    amount: storeCodeSubtotalByDate,
                    infoType: 3, // 註記 = [1 => data, 2 => 小計, 3 => 合計]
                };
                dateGroupNewInfoList.push(dateGroupItem);
                this.$set(this.byGroupDateMap, thisStoreCode, dateGroupNewInfoList);

                // ---------------------------------------------------------------------------------------------------------------------

                // 明細 - 統計"特店合計""
                let storeCodeCount = 0;
                let storeCodeSubtotal = 0;

                const terminalGroupNewInfoList: GroupItem[] = []; // 端末機彙總
                const terminalNewInfoList: TCBReceiptApi.Protobuf.IReimbursementInfo[] = []; // 明細 - 紀錄所有的資料 => (組好同一層直接v-for)

                const terminalMap = storeCodeMap[thisStoreCode].byTerminalNo as TCBReceiptApi.Protobuf.ReimbursementFirstMap;
                if (terminalMap && terminalMap.byFirstColumn) {
                    Object.keys(terminalMap.byFirstColumn).forEach(thisTerminalNo => {
                        const dateMap = terminalMap.byFirstColumn[thisTerminalNo].bySecondColumn as { [k: string]: TCBReceiptApi.Protobuf.IReimbursementBatchNoMap };
                        if (dateMap) {
                            // 明細 - 統計"端末機號小結""
                            let terminalCount = 0;
                            let terminalSubtotal = 0;

                            Object.keys(dateMap).forEach(thisDate => {
                                // 彙總 - 小計
                                // 明細 - 統計"每日小結""
                                let dateSubtotal = 0;
                                let dateCount = 0;

                                const batchNoMap = dateMap[thisDate].byBatchNo as { [k: string]: TCBReceiptApi.Protobuf.Reimbursement };
                                if (batchNoMap) {
                                    Object.keys(batchNoMap).forEach(thisBatchNo => {
                                        const list = batchNoMap[thisBatchNo].list as TCBReceiptApi.Protobuf.ReimbursementInfo[];

                                        // 彙總 - Lb table
                                        const tableInfo: (TCBReceiptApi.Protobuf.ReimbursementInfo | GroupItem)[] = [];

                                        // 明細 - 統計"批號小結""
                                        const count = list.length;
                                        let subtotal = 0;
                                        let batchNo = "";

                                        list.forEach((thisInfo) => {
                                            if (thisInfo.infoType == 1) {
                                                // 彙總
                                                tableInfo.push(thisInfo);

                                                // 明細
                                                terminalNewInfoList.push(thisInfo);
                                                // 批號小結
                                                subtotal = subtotal + (thisInfo.amount as number);
                                                batchNo = thisInfo.batchNo as string; // 四碼
                                                // 每日小結
                                                dateCount = dateCount + 1;
                                                dateSubtotal = dateSubtotal + (thisInfo.amount as number);
                                                // 端末機號小結
                                                terminalCount = terminalCount + 1;
                                                terminalSubtotal = terminalSubtotal + (thisInfo.amount as number);
                                                // 特店合計
                                                storeCodeCount = storeCodeCount + 1;
                                                storeCodeSubtotal = storeCodeSubtotal + (thisInfo.amount as number);
                                            }
                                        });

                                        // 依端末機彙總 - LB table - 批號小結
                                        const tableSubTotalItem: GroupItem =
                                        {
                                            terminalNo: "",
                                            date: "",
                                            batchNo: batchNo,
                                            count: count,
                                            amount: subtotal,
                                            infoType: 2, // 註記 = [1 => data, 2 => 批號小結]
                                        };
                                        tableInfo.push(tableSubTotalItem);

                                        // 依端末機彙總 - LB table
                                        // this.$set(this.byGroupTerminalTableMap, thisBatchNo, tableInfo);
                                        const timeToKey = thisDate.split(" ")[0].split("/").join("") as string;
                                        const byGroupTerminalTableMapKey = thisStoreCode + "_" + thisTerminalNo + "_" + timeToKey + "_" + thisBatchNo;  // 依端末機彙總索引key
                                        console.log("依端末機彙總索引key");
                                        console.log(byGroupTerminalTableMapKey);
                                        this.$set(this.byGroupTerminalTableMap, byGroupTerminalTableMapKey, tableInfo);

                                        // 依端末機彙總 - data
                                        const terminalGroupItem: GroupItem =
                                        {
                                            terminalNo: thisTerminalNo,
                                            date: thisDate,
                                            batchNo: thisBatchNo,
                                            count: list.length,
                                            amount: subtotal,
                                            infoType: 1, // 註記 = [1 => data, 2 => 小計, 3 => 合計]
                                        };
                                        terminalGroupNewInfoList.push(terminalGroupItem);

                                        // 明細 - 批號小結的小計(同批號)
                                        const subTotalItem: { itemName: string; infoType: number; amount: number; count: number; } =
                                        {
                                            itemName: batchNo, // 四碼
                                            infoType: 2, // 註記 = [1 => data, 2 => 批號小結的小計(同批號), 3 => 每日小結, 4 => 端末機號小結, 5 => 合計]
                                            amount: subtotal,
                                            count: count,
                                        };
                                        terminalNewInfoList.push(subTotalItem);
                                    });
                                }

                                // 依端末機彙總 - 小計
                                const terminalGroupItem: GroupItem =
                                {
                                    terminalNo: thisTerminalNo,
                                    date: thisDate,
                                    batchNo: "",
                                    count: dateCount,
                                    amount: dateSubtotal,
                                    infoType: 2, // 註記 = [1 => data, 2 => 小計, 3 => 合計]
                                };
                                terminalGroupNewInfoList.push(terminalGroupItem);

                                // 明細 - 每日小結
                                // 觀念 : 為了要讓每日小結與批號小結同層 在此無法使用push新增 而是對當前terminalNewInfoList列表最後一筆做編輯 額外設定每日小結
                                // 實作 : 直接使用arr.pop() 取得最後一組item且原先arr會被移除 再插入新整理好的item
                                const lastItem = terminalNewInfoList.pop() as { itemName: string; infoType: number; amount: number; count: number; };
                                if (lastItem) {
                                    const editItem: { itemName: string; infoType: number; amount: number; count: number; dateAmount: number } = {
                                        itemName: lastItem.itemName, // 四碼
                                        infoType: 3, // 註記 = [1 => data, 2 => 批號小結的小計(同批號), 3 => 每日小結, 4 => 端末機號小結, 5 => 合計]
                                        amount: lastItem.amount,
                                        count: lastItem.count,
                                        dateAmount: dateSubtotal,
                                    };
                                    terminalNewInfoList.push(editItem);
                                }
                            });

                            // 明細 - 端末機號小結
                            const subTotalItem: { itemName: string; infoType: number; amount: number; count: number; } =
                            {
                                itemName: thisTerminalNo,
                                infoType: 4, // 註記 = [1 => data, 2 => 批號小結的小計(同批號), 3 => 每日小結, 4 => 端末機號小結, 5 => 合計]
                                amount: terminalSubtotal,
                                count: terminalCount,
                            };
                            terminalNewInfoList.push(subTotalItem);
                        }
                    });
                }

                // 依端末機彙總 - 合計
                const terminalGroupItem: GroupItem =
                {
                    terminalNo: "",
                    date: "",
                    batchNo: "",
                    count: storeCodeCount,
                    amount: storeCodeSubtotal,
                    infoType: 3, // 註記 = [1 => data, 2 => 小計, 3 => 合計]
                };
                terminalGroupNewInfoList.push(terminalGroupItem);

                // 明細 - 合計
                const subTotalItem: { itemName: string; infoType: number; amount: number; count: number; } =
                {
                    itemName: thisStoreCode,
                    infoType: 5, // 註記 = [1 => data, 2 => 批號小結的小計(同批號), 3 => 每日小結, 4 => 端末機號小結, 5 => 合計]
                    amount: storeCodeSubtotal,
                    count: storeCodeCount,
                };
                terminalNewInfoList.push(subTotalItem);

                this.$set(this.byTerminalNoMap, thisStoreCode, terminalNewInfoList);

                this.$set(this.byGroupTerminalMap, thisStoreCode, terminalGroupNewInfoList);
            });
        }
    }
    /* 其他 */

    /* 展開收合 */
    private checkIsUnfold(storeCode: string) {
        let isUnfold = false;
        this.unfoldList.some((thisStoreCode) => {
            if (thisStoreCode === storeCode) {
                isUnfold = true;
                return true;
            }
        });
        return isUnfold;
    }
    /* 展開收合 */

    /* 取得最新的權限map並判斷有何權限 */
    private async setPriv() {
        const meta = this.$route.meta as { privKey: { controller: string, method: string, type: string } };
        console.log(meta);

        const isSetPriv = await Priv._checkPriv(meta.privKey);
        if (!isSetPriv) {
            this.$router.push(DefaultPath);  // priv
        }

        if (!Priv._checkPrivType(meta.privKey.type)) {
            this.$router.push(DefaultPath);  // priv
        }
    }
    /* 取得最新的權限map並判斷有何權限 */

    private init() {
        this.byGroupDateTableMap = {};
        this.byGroupDateMap = {};
        this.byGroupTerminalTableMap = {};
        this.byTerminalNoMap = {};
        this.byGroupTerminalMap = {};
    }
}